module.exports = __webpack_public_path__ + "static/img/4.7f3e684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newTwo/4.png
// module id = 44ad
// module chunks = 0